/* eslint-disable import/prefer-default-export */
import type { RootState } from 'state/reducers';
import type { Errors } from 'state/shared';

export const selectCurrentStep = (state: RootState): number =>
  state.signUpSteps.currentStep;

export const selectIsValid = (state: RootState): boolean =>
  state.signUpSteps.isValid;

export const selectPending = (state: RootState): boolean =>
  state.signUpSteps.pending;

export const selectCurrentUser = (state: RootState): string | null =>
  state.signUpSteps.currentUser;

export const selectErrors = (state: RootState): Errors =>
  state.signUpSteps.errors;

// TODO: remove once email sending is sorted out
export const selectVerificationToken = (state: RootState): string | null =>
  state.signUpSteps.verificationToken;
